import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import ChannelsPage from "../pages/channels/page";
import ChannelPage from "../pages/channel/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "channels", element: <ChannelsPage /> },
      { path: "channel/:slug", element: <ChannelPage /> },
      { path: "article/:slug", element: <ArticlePage /> },
      { path: "about", element: <AboutPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;